module.exports = __webpack_public_path__ + "static/img/Arrow.b80a9d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Arrow.gif
// module id = 57pk
// module chunks = 1